import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
class LoadingView extends Component {

  render() {
    let { isOpen, isGlobal } = this.props;

    return !!isOpen ? (
      <div className={"loading-view" + (isGlobal ? "" : " block")}>
        <div className="lds-ring">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    ) : null;
  }
}

export default LoadingView;


export function LoadingComponent({
  style,
  size = 40,
  className,
  show,
  position = '',
  children
}) {
  const customStyle = {
    group: {

    },
    loading: {

    },
    ...style,
  }
  const customClassName = {
    group: '',
    loading: '',
    ...className,
  }
  return (
    <React.Fragment>
      {show && (
        <div style={{ ...customStyle.group, justifyContent: position, minHeight: size + 5 }} className={`${customClassName.group} d-flex`}>
          <CircularProgress size={size} style={{ ...customStyle.loading, color: '#fe5522' }} className={`${customClassName.loading} text-primary`} />
        </div>
      )}
      {!show && children}
    </React.Fragment>
  )
}
